/**
 * "What's coming next" ribbon — self-gated by featureRoadmapHints, so it's
 * safe to mount unconditionally from Layout. Dismissal is remembered per next
 * phase (not just "dismissed forever"): once that phase ships and a new one
 * becomes "next", the ribbon reappears with the new teaser.
 */
import { useState } from 'react';
import { Alert } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useNodeInfo } from '../../hooks/use_node_info';
import { useSuperAdmins } from '../../hooks/use_super_admins';
import { getNextPhase } from '../../roadmapData';

const DISMISS_KEY = 'vellby_whats_new_dismissed_phase';

function WhatsNewRibbon() {
    const nodeInfo = useNodeInfo();
    const navigate = useNavigate();
    // The map moved into node settings, which 403s for everyone else — so for
    // a non-admin the ribbon is a teaser with nothing to click through to.
    const { isServerAdmin } = useSuperAdmins();
    const nextPhase = getNextPhase(nodeInfo);
    const [dismissedPhaseId, setDismissedPhaseId] = useState(() => {
        try {
            return localStorage.getItem(DISMISS_KEY);
        } catch {
            return null;
        }
    });

    if (!nodeInfo.featureRoadmapHints || !nextPhase || dismissedPhaseId === nextPhase.id) {
        return null;
    }

    const dismiss = () => {
        try {
            localStorage.setItem(DISMISS_KEY, nextPhase.id);
        } catch {
            // localStorage unavailable (private mode, etc.) — dismiss for this session only
        }
        setDismissedPhaseId(nextPhase.id);
    };

    return (
        <Alert
            banner
            closable
            type="info"
            onClose={dismiss}
            style={isServerAdmin ? { cursor: 'pointer' } : undefined}
            onClick={isServerAdmin ? (e) => {
                if (e.target.closest('.ant-alert-close-icon')) return;
                navigate('/node-account/map');
            } : undefined}
            message={(
                <>
                    Next up: <strong>{nextPhase.title}</strong> — {nextPhase.description}
                    {isServerAdmin && ' See the full map →'}
                </>
            )}
        />
    );
}

export default WhatsNewRibbon;
